module.exports = __webpack_public_path__ + "img/btn_shitu_ov.e0117660.png";